import controller from './admin-class-designer.controller';
import template from './admin-class-designer.html';
import '../schema.scss';
import './admin-class-designer.scss';

export default {
	controller,
	controllerAs:   '$ctrl',
	path:           '/admin/class-designer',
	reloadOnSearch: false,
	template,
	title:          'menu.class-designer',
};
